export default "__VITE_ASSET__BL3Z6j$X__"